
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';

interface AIAdvisorProps {
  companyName: string;
  onStartChat: () => void;
}

const AIAdvisor: React.FC<AIAdvisorProps> = ({ companyName, onStartChat }) => {
  return (
    <Card className="bg-white border border-redflags-light/20">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg font-medium text-redflags-dark text-center">
          AI Advisor
        </CardTitle>
      </CardHeader>
      <CardContent className="text-center">
        <p className="text-gray-600 mb-4 text-sm">
          Click here to chat with our RedFlags AI Agent about this company
        </p>
        <Button
          onClick={onStartChat}
          className="w-full bg-redflags-red hover:bg-redflags-red/90 text-white flex items-center justify-center gap-2"
        >
          <MessageCircle className="w-4 h-4" />
          Start AI Chat
        </Button>
      </CardContent>
    </Card>
  );
};

export default AIAdvisor;
